import { WalletOutlineIcon } from './WalletOutlineIcon';

/**
 * author: Google
 * id BE3A6C7B-398B-4B7D-B7F3-7EDE9220F489
 * name wallet-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wallet-outline.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const AccountBalanceWalletOutlineIcon = WalletOutlineIcon;
export default AccountBalanceWalletOutlineIcon